import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */
export async function getVigenciasMora(data) {
  try {
    const response = await axios.post("/ActivosO/VigenciasMora/CT0/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function upsertVigenciasMora(data) {
  try {
    const response = await axios.post("/ActivosO/VigenciasMora/UpsertVigenciaMora/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}